import { useMemo } from "react";
import { Box, Button, FormControl, MenuItem, Select } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { buildColumnsMenus } from "../config/columns";
import { buildRowActions } from "./RowActionMenu";

const bgColorTableHeadCell = "rgba(212, 230, 241, 0.8)";

const MenusTable = ({
  data = [],
  loading,
  onAction,
  onNuevo,
  proveedores = [],
  filtroProveedor,
  onFiltroProveedorChange,
}) => {
  const columns = useMemo(() => buildColumnsMenus(), []);

  return (
    <Box boxShadow={3} sx={{ borderRadius: 2, overflow: "hidden" }}>
      <MaterialReactTable
        columns={columns}
        data={data}
        localization={MRT_Localization_ES}
        enableRowActions
        positionActionsColumn="last"
        enableColumnActions={false}
        enableColumnFilters={false}
        enableColumnOrdering={false}
        enableGrouping={false}
        enableHiding={false}
        enableDensityToggle={false}
        state={{ isLoading: loading, showSkeletons: loading }}
        initialState={{ density: "compact", pagination: { pageIndex: 0, pageSize: 25 } }}
        muiSearchTextFieldProps={{
          placeholder: "Buscar menú..",
          sx: { minWidth: "14rem", backgroundColor: "#ffffff" },
          variant: "outlined",
          size: "small",
        }}
        renderTopToolbarCustomActions={() => (
          <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={onNuevo}
              sx={{ borderRadius: 3, textTransform: "none", fontWeight: 600 }}
            >
              Nuevo menú
            </Button>
            <FormControl size="small" sx={{ minWidth: 200 }}>
              <Select
                displayEmpty
                value={filtroProveedor}
                onChange={(e) => onFiltroProveedorChange(e.target.value)}
                sx={{ bgcolor: "white" }}
              >
                <MenuItem value="">
                  <em>Todos los proveedores</em>
                </MenuItem>
                {proveedores.map((p) => (
                  <MenuItem key={p.id} value={p.id}>
                    {p.nombre}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}
        muiTableHeadCellProps={{
          sx: {
            fontSize: 14,
            color: "black",
            fontWeight: "normal",
            backgroundColor: bgColorTableHeadCell,
            borderColor: "#FDFEFE",
          },
        }}
        muiTableBodyCellProps={{
          sx: { borderBottom: "1px solid rgba(224,224,224,1)" },
        }}
        renderRowActionMenuItems={({ closeMenu, row }) =>
          buildRowActions({ row: row.original, closeMenu, onAction })
        }
      />
    </Box>
  );
};

export default MenusTable;
